import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const portfolioRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.portfolios,
    name: routeNames.portfolios,
    component: () => import('@/pages/portfolios/PortfoliosView.vue'),
    meta: {
      icon: 'material-symbols-outlined',
      iconText: 'wallet',
      labelKey: 'portfolios',
      permission: 'portfolios.read.all',
      featureFlag: 'portfolios',
    },
  },
]
